export default __webpack_public_path__ + "static/media/KAIRA_D3.a1756266.jpg";